module.exports = __webpack_public_path__ + "img/action-like-active.e953ed71.svg";